export enum PageMutationTypes {
  SET_THREE_MODE = 'SET_THREE_MODE',
  SET_RENDERING_MODE = 'SET_RENDERING_MODE'
}
